import type { App, Plugin } from "vue";

const isSubmitShortcut = (event: KeyboardEvent) =>
  event.key === "Enter" && (event.metaKey || event.ctrlKey);

const submitFocusedForm = (event: KeyboardEvent) => {
  if (
    !isSubmitShortcut(event) ||
    event.defaultPrevented ||
    event.repeat ||
    event.isComposing
  ) {
    return;
  }

  if (!(event.target instanceof Element)) {
    return;
  }

  const submitButton = event.target
    .closest("form")
    ?.querySelector<HTMLButtonElement>('button[type="submit"]');

  if (!submitButton) {
    return;
  }

  event.preventDefault();
  submitButton.click();
};

const plugin: Plugin = {
  install: (app: App<Element>) => {
    document.addEventListener("keydown", submitFocusedForm);
    app.onUnmount(() => {
      document.removeEventListener("keydown", submitFocusedForm);
    });
  },
};

export default plugin;
